import { lazy } from 'react';
/** Открывает карточку подписки клиента */
export const ClientSubscriptionDetailsPageAsync = lazy(() => import('./ClientSubscriptionDetails/ClientSubscriptionDetailsPage'));